import * as React from "react";
import { MessageCard, MessageCardSeverity } from "azure-devops-ui/MessageCard";

export default class InfoExample extends React.Component {
    public render(): JSX.Element {
        const message: string = "Some services are not supported in this project.";

        return (
            <MessageCard
                className="flex-self-stretch"
                onDismiss={this.onDismiss}
                severity={MessageCardSeverity.Info}
            >
                {message}
            </MessageCard>
        );
    }

    private onDismiss = () => {
        alert("Parents should use onDismiss to stop rendering the Message Bar");
    };
}
